'use strict';

import React from 'react';

import appConstants from 'constants/appConstants';

import PageSection from 'components/base/PageSection';
import WidgetCount from 'components/base/WidgetCount';
import WidgetHeading from 'components/base/WidgetHeading';

import _ from 'underscore';

const propTypes = {};

const PendingLeaveApprovalsWidget = (props) => {

    var value = null;
    var unit = "Fetching Pending Leave Approvals...";

    if (props.approvalsData && props.approvalsData.approvals) {
        value = _.filter(props.approvalsData.approvals, {WorkflowType: appConstants.ENUMS.WORKFLOW_TYPES.LEAVE}).length;
        unit = (
            <WidgetHeading
                label="Leave Application"
                subText="Pending Approvals"
            />
        );
    }

    return (
        <PageSection 
            id="pending-leave-approvals-widget"
            backgroundColorClass="background-color-leave"
            link="approvals/"
            query={{c:appConstants.ENUMS.APPROVALS_VIEW_OPTIONS.LEAVE.VALUE}}
        >
            <WidgetCount 
                iconName="icon-leave-approvals" 
                value={value} 
                unit={unit}
            />
        </PageSection>
    );
};

PendingLeaveApprovalsWidget.propTypes = propTypes;

export default PendingLeaveApprovalsWidget; 